import { ProductTransferDetailsResponseDto } from '@tiendanube/common';
import { ProductInterface } from 'domains/Orders/components/ProductSearcher/types';

export type TransferProductVariant = ProductInterface<false> & {
  quantity?: number;
};

export type TransferProduct = Pick<
  ProductInterface<false>,
  'productId' | 'name' | 'imageUrl'
>;

export const extractTransferProduct = (products: ProductInterface<false>[]) => {
  const uniqueProducts = new Map<string, TransferProduct>();

  products.forEach((product) => {
    if (!uniqueProducts.has(product.productId)) {
      uniqueProducts.set(product.productId, {
        productId: product.productId,
        name: product.name,
        imageUrl: product.imageUrl,
      });
    }
  });

  return Array.from(uniqueProducts.values());
};

export const extractTransferProductDetails = (
  products: ProductTransferDetailsResponseDto['productVariants'],
) => {
  const uniqueProducts = new Map<string, TransferProduct>();

  products.forEach((product) => {
    if (!uniqueProducts.has(product.productId)) {
      uniqueProducts.set(product.productId, {
        productId: product.productId,
        name: product.productName,
        imageUrl: product.productImage,
      });
    }
  });

  return Array.from(uniqueProducts.values());
};
